export const DROPDOWN_MEGA_TOOLTIP_WIDTH = 250;
export const SPACE_BELOW_BUTTON_AND_ARROW = '62px';
export const SPACE_RIGHT_OF_DROPDOWN = '-35px';
export const BORDER_WIDTH = 10;
